import React from 'react';

import {useCharacter} from '../../character-context';
import {AbilityMethod, initialGeneration, pointBuyStart} from '../../model/ability-generation';
import {FilterChips} from '../../sheet/filter-chips';
import {ManualScores} from './manual-scores';
import {PointBuy} from './point-buy';
import {RandomScores} from './random-scores';
import {StandardArray} from './standard-array';

import css from '../master.module.css';

const METHODS: {method: AbilityMethod; title: string; description: string}[] = [
	{
		method: 'standard',
		title: 'Стандартный набор',
		description: 'Используйте для ваших характеристик шесть значений: 15, 14, 13, 12, 10, 8.',
	},
	{
		method: 'pointBuy',
		title: 'Приобретение за очки',
		description:
			'У вас есть 27 очков, которые можно распределить между характеристиками. Цена значения указана рядом с ним: 14 стоит 7 очков, 15 — 9.',
	},
	{
		method: 'random',
		title: 'Случайный набор',
		description:
			'Бросьте четыре d6 и сложите три наибольших результата. Сделайте так ещё пять раз, чтобы получить шесть чисел, и распределите их между характеристиками.',
	},
	{method: 'manual', title: 'Ручной набор', description: 'Введите значения сами.'},
];

/** шаг мастера: базовые значения характеристик одним из четырёх способов */
export const AbilitiesStep: React.FC = () => {
	const {state, update} = useCharacter();
	const generation = state.abilityGeneration ?? initialGeneration('standard');
	const {description} = METHODS.find(({method}) => method === generation.method) || METHODS[0];

	const setMethod = (method: AbilityMethod) => {
		if (method === generation.method) return;
		update({
			abilityGeneration: initialGeneration(method),
			...(method === 'pointBuy' ? {baseAbilities: pointBuyStart()} : null),
		});
	};

	return (
		<>
			<p className={css.hint}>
				Это значения до повышений. Происхождение, черты и особенности добавятся к ним сами — итог виден справа
				от поля.
			</p>
			<FilterChips
				label="Способ набора"
				items={METHODS.map(({method, title}) => ({value: method, label: title}))}
				value={generation.method}
				onChange={setMethod}
			/>
			<p>{description}</p>
			{generation.method === 'standard' && <StandardArray assigned={generation.assigned} />}
			{generation.method === 'pointBuy' && <PointBuy />}
			{generation.method === 'random' && <RandomScores generation={generation} />}
			{generation.method === 'manual' && <ManualScores />}
		</>
	);
};
